module.exports = __webpack_public_path__ + "media/images/apple-3e208bda7fa6a756d88427e0eb2123f7.svg";